module.exports = __webpack_public_path__ + "img/shape4.f044bf53.svg";